import React, { PropTypes } from 'react';
import {
  FAN_FEED_TAGS,
  FAN_FEED_POSTS,
  FAN_FEED_SLIDESHOW
} from '../../../api/fan_feed';
import { Tabs, Tab } from 'material-ui/Tabs';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';

class FanFeedRoot extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  defaultProps = {
    displayStatus: false
  };

  state = {
    openSpeedDial: false
  };

  headerTitle = 'FanFeed';

  _toggleSpeedDial() {
    let { openSpeedDial } = this.state;
    openSpeedDial = !openSpeedDial;
    this.setState({ openSpeedDial });
  }

  intialSelectedTab() {
    const path = this.props.location.pathname.split('/')
    switch (path[2]) {
      case FAN_FEED_TAGS:
        return 0;
      case FAN_FEED_POSTS:
        return path[3] == FAN_FEED_SLIDESHOW ? 2 : 1;
      default:
        return 1;
    }
  }

  render() {
    const { children } = this.props;
    
    let {
      palette: { labelColor }
    } = this.context.muiTheme;
    return (
      <div>
        <LoggedAppBar
          title={this.headerTitle}
          isStatic={true}
          childrenHeight={-40}
        >
          <Tabs initialSelectedIndex={this.intialSelectedTab()}>
            <Tab
              style={{ color: labelColor }}
              label="Tags"
              onClick={this.props.goToTags}
              value={FAN_FEED_TAGS}
            />
            <Tab
              style={{ color: labelColor }}
              label="Posts"
              onClick={this.props.goToPosts}
              value={FAN_FEED_POSTS}
            />
            {/* <Tab
              style={{ color: labelColor }}
              label="SlideShow"
              onClick={this.props.goToSlideShow}
              value={FAN_FEED_SLIDESHOW}
            /> */}
          </Tabs>
        </LoggedAppBar>
        {children}
      </div>
    );
  }
}

export default FanFeedRoot;



// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedRoot/FanFeedRoot.jsx